import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import {
  DOWNTIME_BANNER_KEY,
  checkHasSeenBannerToday,
} from 'constants/banner-types';
import { MARKETING } from 'constants/error-severities';
import {
  MARKETING_BANNER_COPY,
  SHOW_MARKETING_BANNER,
} from 'constants/featureFlag';
import { getFeatureFlagCreator } from 'creators/featureFlag';

const useDowntimeBanner = () => {
  const dispatch = useDispatch();

  const showMarketingBanner = useSelector(state => {
    const flagData = state.feature_flags[SHOW_MARKETING_BANNER];

    if (!flagData) {
      return false;
    }

    return flagData.value;
  });

  const marketingBannerCopy = useSelector(state => {
    const flagData = state.feature_flags[MARKETING_BANNER_COPY];

    if (!flagData) {
      return null;
    }

    return flagData.value;
  });

  useEffect(() => {
    dispatch(getFeatureFlagCreator(SHOW_MARKETING_BANNER));
    dispatch(getFeatureFlagCreator(MARKETING_BANNER_COPY));
  }, [dispatch]);

  useEffect(() => {
    const hasSeenBannerToday = checkHasSeenBannerToday();

    if (showMarketingBanner && marketingBannerCopy && !hasSeenBannerToday) {
      dispatch(
        showErrorBar(MARKETING, marketingBannerCopy, DOWNTIME_BANNER_KEY)
      );
    }
  }, [dispatch, showMarketingBanner, marketingBannerCopy]);
};

export default useDowntimeBanner;
